import AdvancedSettings from './advanced-settings'

export default AdvancedSettings
